import React, { ReactNode } from "react";
import { render } from "storyblok-rich-text-react-renderer";
import { LinkAttributes } from "./login/Login.types";
import { viewport, isTouchScreen } from "../utils/utils";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { AssetPathPropConfig } from "../services/LineTableBasicPropConfig";
export interface RichTextSchema {
  content: Array<Object>;
  isIFrame?: boolean;
  trackngLabel?: string;
  linkAsTooltip?: boolean;
  toolTipText?: string;
}

const RichText: React.FunctionComponent<RichTextSchema> = (props) => {
  const viewPort = viewport();
  const touchDevice = isTouchScreen();
  const isTouchScreenDevice =
    viewPort === "mobile" || viewPort === "tablet" || touchDevice;
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();

  return (
    <div>
      {render(props.content, {
        markResolvers: {
          link:(
            children: ReactNode | undefined,
            attrs: any
          ): any => {
            const { href, target, linktype} = attrs;

            if (linktype === "email") {
              // Email links: add `mailto:` scheme and map to <a>
              return (
                <a
                  href={`mailto:${href}`}
                  target={
                    target === null || target === "_self" ? "_top" : "_blank"
                  }
                >
                  {children}
                </a>
              );
            }

            // for iframe the page has to be opened in the top
            if (props.isIFrame) {
              return (
                <a
                  href={href}
                  target={
                    target === null || target === "_self" ? "_top" : "_blank"
                  }
                >
                  {children}
                </a>
              );
            }

            return (
              <>
                {props?.linkAsTooltip && props?.toolTipText ? (
                  <OverlayTrigger
                    placement="auto"
                    rootClose
                    trigger={isTouchScreenDevice ? "click" : "hover"}
                    overlay={
                      props?.toolTipText ? (
                        <Popover id='popover-basic'>
                          <Popover.Body>
                            {props?.toolTipText}
                            {isTouchScreenDevice && assetPath && (
                              <img
                                src={`${assetPath}/icons/overlay-close.svg`}
                                alt="close"
                                style={{ float: "right" }}
                                width={24}
                                height={24}
                                onClick={() => document?.body?.click()}
                              />
                            )}
                          </Popover.Body>
                        </Popover>
                      ) : (
                        <></>
                      )
                    }
                  >
                    <span>{children}</span>
                  </OverlayTrigger>
                ) : (
                  <a
                    href={href}
                    target={target === null ? "" : target}
                  >
                    {children}
                  </a>
                )}
              </>
            );
          },
        },
      })}
    </div>
  );
};

export default RichText;
